import React from 'react';
import { NavLink } from 'react-router-dom';
import { clsx } from 'clsx';
import { Icon, Badge } from '@/design-system/primitives';
import type { NavItemConfig } from './types';

export interface NavItemProps {
  item: NavItemConfig;
  active: boolean;
  collapsed: boolean;
  badge?: number;
}

export const NavItem: React.FC<NavItemProps> = ({ item, active, collapsed, badge }) => {
  return (
    <NavLink
      to={item.route}
      title={collapsed ? item.label : undefined}
      className={clsx(
        'mx-2 my-0.5 flex items-center gap-2 px-3 py-2 text-sm rounded transition-colors',
        active
          ? 'bg-accent-soft text-accent-ink font-medium'
          : 'text-text-soft hover:bg-surface-muted',
        collapsed && 'justify-center mx-1',
      )}
    >
      <Icon name={item.icon} size={collapsed ? 20 : 18} />
      {!collapsed && (
        <>
          <span className="flex-1 truncate">{item.label}</span>
          {badge !== undefined && badge > 0 && (
            <Badge variant="err" size="sm">
              {badge}
            </Badge>
          )}
        </>
      )}
    </NavLink>
  );
};
